/* eslint-disable */
import { useMemo } from 'react';
import PropTypes from 'prop-types';

import CssBaseline from '@mui/material/CssBaseline';
import { createTheme, ThemeProvider as MUIThemeProvider } from '@mui/material/styles';

import { userPalette,companyPalette,palette } from './palette';
import { shadows } from './shadows';
import { overrides } from './overrides';
import { typography } from './typography';
import { customShadows } from './custom-shadows';

// ----------------------------------------------------------------------

export default function ThemeProvider({ children }) {

  // const user = JSON.parse(localStorage.getItem("User"));
  // let pale;
  // if (user) {
  //   if (user.role===1) {
  //     pale = palette();
  //   }
  //   else
  //     pale = user.role===3?userPalette():companyPalette();
  // }
  // else
  // {
   const pale = palette();
  // }
  
  const memoizedValue = useMemo(
    () => ({
      palette:pale,
      typography,
      shadows: shadows(),
      customShadows: customShadows(),
      shape: { borderRadius: 8 },
    }),
    [pale]
  );

  const theme = createTheme(memoizedValue);

  theme.components = overrides(theme);

  return (
    <MUIThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </MUIThemeProvider>
  );
}

ThemeProvider.propTypes = {
  children: PropTypes.node,
};
